"use strict";

define('uikit/uikit',['marionette', 'underscore', 'json!./version.json', './mixins/component.mixin', './mixins/injector.mixin', './elements/button', './elements/checkbox', './elements/dropdown', './elements/header', './elements/input', './elements/label', './elements/progress', './elements/text', './elements/select', './elements/divider', './collections/breadcrumb', './collections/checkbox.group', './collections/container', './collections/form', './collections/grid', './collections/list', './collections/search.results', './collections/segment.list', './collections/steps', './collections/table', './collections/tabs', './collections/tree', './modules/accordion', './modules/calendar', './modules/dimmer', './modules/expandable.menu', './modules/input.counter', './modules/input.date', './modules/input.time', './modules/instant.notifications', './modules/loader', './modules/menu', './modules/message', './modules/modal', './modules/pagination', './modules/popup', './modules/sidebar', './modules/tag.input', './modules/token.input', './modules/tutorial', './modules/visualsearch', './views/form.wrapper', './views/table.add', './views/table.ellipsis', './views/table.navigation', './views/table.remove', './views/table.selected', './extra/size'], function (Mn, _, version, ComponentMixin, InjectorMixin, Button, Checkbox, Dropdown, Header, Input, Label, Progress, Text, Select, Divider, Breadcrumb, CheckboxGroup, Container, Form, Grid, List, SearchResults, SegmentList, Steps, Table, Tabs, Tree, Accordion, Calendar, Dimmer, ExpandableMenu, InputCounter, InputDate, InputTime, InstantNotifications, Loader, Menu, Message, Modal, Pagination, Popup, Sidebar, TagInput, TokenInput, Tutorial, VisualSearch, EditableField, TableAdd, TableEllipsis, TableNavigation, TableRemove, TableSelected, Size) {
  var UIKit = this.UIKit = this.UIKit || {};
  UIKit.version = version.version;
  _.extend(UIKit, {
    ComponentMixin: ComponentMixin,
    InjectorMixin: InjectorMixin,
    Button: Button,
    Checkbox: Checkbox,
    Dropdown: Dropdown,
    Header: Header,
    Input: Input,
    Label: Label,
    Progress: Progress,
    Text: Text,
    Select: Select,
    Divider: Divider,
    Breadcrumb: Breadcrumb,
    CheckboxGroup: CheckboxGroup,
    Container: Container,
    Form: Form,
    Grid: Grid,
    List: List,
    SearchResults: SearchResults,
    SegmentList: SegmentList,
    Steps: Steps,
    Table: Table,
    Tabs: Tabs,
    Tree: Tree,
    Accordion: Accordion,
    Calendar: Calendar,
    Dimmer: Dimmer,
    ExpandableMenu: ExpandableMenu,
    InputCounter: InputCounter,
    InputDate: InputDate,
    InputTime: InputTime,
    InstantNotifications: InstantNotifications,
    Loader: Loader,
    Menu: Menu,
    Message: Message,
    Modal: Modal,
    Pagination: Pagination,
    Popup: Popup,
    Sidebar: Sidebar,
    TagInput: TagInput,
    TokenInput: TokenInput,
    Tutorial: Tutorial,
    VisualSearch: VisualSearch,
    EditableField: EditableField,
    TableAdd: TableAdd,
    TableEllipsis: TableEllipsis,
    TableNavigation: TableNavigation,
    TableRemove: TableRemove,
    TableSelected: TableSelected,
    Size: Size,
    ItemView: Mn.ItemView.extend(ComponentMixin),
    CollectionView: Mn.CollectionView.extend(ComponentMixin),
    ComponentView: Mn.CompositeView.extend(ComponentMixin),
    CompositeView: Mn.CompositeView.extend(ComponentMixin)
  });
  return UIKit;
});

